<template>
  <screen-loading></screen-loading>
</template>

<script>
import enums from '@/utils/enums';
import { USER, UNIT, CONFIG } from '@/utils/constants';
import { clearStore } from '@/services/storage';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import { setLGPDConsentBanner } from '@/services/lgpdSecuriti';
import {
  setToken,
  setAdminPreview,
  removeAdminPreview,
  setAccessType,
} from '@/services/auth';
import { ROLES } from '../utils/constants';

export default {
  components: {
    ScreenLoading,
  },

  created() {
    this.loginByAdminPreview();
  },

  methods: {
    async loginByAdminPreview() {
      clearStore();

      this.$store.commit(UNIT.MUTATE, []);
      this.$store.dispatch(UNIT.SELECT, null);

      removeAdminPreview();

      const currentRoute = this.$router.currentRoute.query;

      const { admin, client, document } = currentRoute;

      const params = {
        userId: client,
        admin: admin,
      };

      const headers = {
        Tenant: this.$store.getters[CONFIG.GET].tenantId,
      };

      // Verify if there is a session for the user
      const session = await this.requestService(
        `${process.env.AUTH_API_URL}/getSession`,
        'GET',
        {
          params,
          auth: false,
          customHeaders: headers,
        }
      );

      // If there is no session, redirect to login
      if (!session) {
        this.$router.push({ name: 'login' });
        return;
      }

      headers.Authorization = session.token;

      const paramsGetUser = {
        username: document,
        userRole: session.userRole,
        ignoreClient: 1,
      };

      const result = await this.requestService(
        `${process.env.AUTH_API_URL}/user/getUser`,
        'GET',
        {
          params: paramsGetUser,
          auth: false,
          customHeaders: headers,
        }
      );

      if (result) {
        setAdminPreview(session.admin);

        setAccessType(enums.accessTypes.admin);

        sessionStorage.setItem('logged', true);
        setToken(session.token, { keepLogged: false });

        await this.requestService(
          `${process.env.AUTH_API_URL}/updateSession`,
          'POST',
          {
            data: {
              userId: session.userId,
              userRole: session.userRole,
              action: 'adminPreview',
              admin: session.admin,
            },
            auth: false,
            customHeaders: headers,
          }
        );

        if (session.userRole == ROLES.SYNDIC_ROLE) {
          const user = result;
          this.$store.commit(USER.MUTATE_USER, user);
          await this.$store.dispatch(UNIT.SYNDIC_PRODUCTS, user);
          this.$router.push({ name: 'syndicSelectProduct' });
        } else {
          this.$store.commit(USER.MUTATE_USER, result.user);
          this.$router.push({ name: 'selectUnit' });
        }

        setLGPDConsentBanner(result?.user?._id || result?._id);
        this.createTrace(this.enums.logTraceActions.loginByAdmin);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/AdminPreview.vue